import { ApiClient } from '@/shared/api/client';
import type { IngestKey, IngestKeyCreated, Orchestrator, Repo, Schedule, Source } from '@/features/ai-dart/types';

export const settingsApi = {
  orchestrators: {
    list: () => ApiClient.getJson<Orchestrator[]>('/ai-dart/orchestrators'),
    create: (input: unknown) => ApiClient.postJson<{ ok: true }>('/ai-dart/orchestrators', input),
    update: (id: number, input: unknown) => ApiClient.patchJson<{ ok: true }>(`/ai-dart/orchestrators/${id}`, input),
    remove: (id: number) => ApiClient.deleteJson<{ ok: true }>(`/ai-dart/orchestrators/${id}`),
    activate: (id: number) => ApiClient.postJson<{ ok: true }>(`/ai-dart/orchestrators/${id}/activate`),
  },
  sources: {
    list: () => ApiClient.getJson<Source[]>('/ai-dart/sources'),
    create: (input: unknown) => ApiClient.postJson<{ ok: true }>('/ai-dart/sources', input),
    update: (id: number, input: unknown) => ApiClient.patchJson<{ ok: true }>(`/ai-dart/sources/${id}`, input),
    remove: (id: number) => ApiClient.deleteJson<{ ok: true }>(`/ai-dart/sources/${id}`),
    toggle: (id: number) => ApiClient.postJson<{ ok: true }>(`/ai-dart/sources/${id}/toggle`),
  },
  repos: {
    list: () => ApiClient.getJson<Repo[]>('/ai-dart/repos'),
    create: (input: unknown) => ApiClient.postJson<{ ok: true; id: number }>('/ai-dart/repos', input),
    update: (id: number, input: unknown) => ApiClient.patchJson<{ ok: true }>(`/ai-dart/repos/${id}`, input),
    remove: (id: number) => ApiClient.deleteJson<{ ok: true }>(`/ai-dart/repos/${id}`),
    refresh: (id: number) => ApiClient.postJson<{ ok: true; message: string }>(`/ai-dart/repos/${id}/refresh`),
  },
  schedules: {
    list: () => ApiClient.getJson<Schedule[]>('/ai-dart/schedules'),
    update: (name: string, input: unknown) => ApiClient.patchJson<{ ok: true }>(`/ai-dart/schedules/${encodeURIComponent(name)}`, input),
    run: (name: string) => ApiClient.postJson<{ ok: true }>(`/ai-dart/schedules/${encodeURIComponent(name)}/run`),
  },
  ingestKeys: {
    list: () => ApiClient.getJson<{ keys: IngestKey[]; endpoint: string }>('/ai-dart/ingest-keys'),
    create: (label: string) => ApiClient.postJson<IngestKeyCreated>('/ai-dart/ingest-keys', { label }),
    revoke: (id: number) => ApiClient.postJson<{ ok: true }>(`/ai-dart/ingest-keys/${id}/revoke`),
  },
};
